import { BOROS } from "./boros";

export function BoroCodeSelect({
  disabled,
  value,
  onChange,
  className,
  name,
}: {
  disabled?: boolean;
  value?: string;
  onChange?: (e: React.ChangeEvent<HTMLSelectElement>) => void;
  className?: string;
  name?: string;
}) {
  return (
    <select
      disabled={disabled || false}
      value={value || ""}
      onChange={onChange}
      name={name}
      className={`${className}${value !== "" ? " selected" : ""}`}
    >
      <option value="">Boros</option>
      {BOROS.map(({ code, name }) => (
        <option key={code} value={code}>
          {name}
        </option>
      ))}
    </select>
  );
}
